import i18n from 'i18next';

/* eslint no-underscore-dangle: ["error", { "allow": ["_i"] }] */
export const _i = (text) => i18n.t(text);
